module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/baseball-c4f9fff5602d4faa06c46c5527f3df0d.svg";